export default __webpack_public_path__ + "static/media/single-tones.63c8dd37.png";